(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ash-foundation"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const drawer = document.querySelector('#m-menu-drawer');
      const trigger = document.querySelector('.m-hamburger-box');
      if (!drawer || !trigger || drawer.dataset.ashFoundationReady) return;
      drawer.dataset.ashFoundationReady = 'true';
      const close = drawer.querySelector('[data-ash-drawer-close]');
      let wasOpen = false;
      const sync = () => {
        const open = drawer.classList.contains('open');
        trigger.setAttribute('aria-expanded', String(open));
        drawer.inert = !open;
        if (open && !wasOpen) close?.focus();
        if (!open && wasOpen && drawer.contains(document.activeElement)) trigger.focus();
        wasOpen = open;
      };
      close?.addEventListener('click', () => { if (drawer.classList.contains('open')) trigger.click(); });
      drawer.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); trigger.click(); }
        if (event.key === 'Tab') {
          const nodes = [...drawer.querySelectorAll('a,button,summary,input,select,[tabindex="0"]')].filter(node => node.getClientRects().length && !node.disabled && getComputedStyle(node).visibility !== 'hidden');
          const first = nodes[0], last = nodes[nodes.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
          else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        }
      });
      new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
      sync();
      document.querySelectorAll('.ash-collection-menu').forEach(menu => menu.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        menu.querySelector('.m-menu__link--main')?.focus();
        menu.classList.add('ash-menu-dismissed');
        menu.classList.remove('m-menu__item--active');
      }));
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
